import { useState } from "react";

export interface ActivityCoreData {
  instruction: string;
  localizedInstruction: string;
  difficulty: string;
  tags: string[];
  isActive: boolean;
  newKeyword: string;
  activityNumber: number;
}

export const useActivityCoreData = (
  initialData?: Partial<ActivityCoreData>
) => {
  const [instruction, setInstruction] = useState(
    initialData?.instruction || ""
  );
  const [localizedInstruction, setLocalizedInstruction] = useState(
    initialData?.localizedInstruction || ""
  );
  const [difficulty, setDifficulty] = useState(initialData?.difficulty || "");
  const [tags, setTags] = useState<string[]>(initialData?.tags || []);
  const [newKeyword, setNewKeyword] = useState("");
  const [activityNumber, setActivityNumber] = useState(
    initialData?.activityNumber || ""
  );
  const [isActive, setIsActive] = useState(initialData?.isActive || false);

  const addKeyword = (keyword: string) => {
    if (keyword.trim() && !tags.includes(keyword.trim())) {
      setTags([...tags, keyword.trim()]);
    }
  };

  const removeKeyword = (index: number) => {
    setTags(tags.filter((_, i) => i !== index));
  };

  const activityNumberToInt = parseInt(activityNumber as string);

  return {
    coreData: {
      instruction,
      localizedInstruction,
      difficulty,
      tags,
      isActive,
      newKeyword,
      activityNumber: activityNumberToInt,
    },
    setInstruction,
    setLocalizedInstruction,
    setDifficulty,
    setIsActive,
    setNewKeyword,
    setActivityNumber,
    addKeyword,
    removeKeyword,
    tags,
    newKeyword,
  };
};
